import { VOIntroductionList, VOIntroductionListItem, VOIntroductionPerson } from "../model/DataStructure.js";
import { Decoration } from "./Decoration.js";
import { Polygon } from "./Polygon.js";

export interface PersonSelectorOptions {
    container: HTMLElement;
    items: VOIntroductionList;
    visible?: boolean;
    onSelect?: (person: VOIntroductionPerson) => void;
}

export class PersonSelector {

    public onSelect = e5.Signal.create<[VOIntroductionPerson]>();

    private _element: HTMLElement;
    private _decoration: Decoration;
    private _items: PersonSelectorItem[] = [];

    constructor(options: PersonSelectorOptions) {
        options = e5.object.merge({

        }, options);

        this._element = document.createElement("div");
        this._element.className = "person-selector";
        this._element.innerHTML = `
        <div class="person-selector__decorations"></div>
        <div class="person-selector__persons"></div>
        `;

        this._decoration = new Decoration({
            container: this._element.querySelector(".person-selector__decorations"),
            visible: true,
            names: [
                "person-selector-1",
                "person-selector-6",
                "person-selector-15",
                "person-selector-17",
            ]
        });

        for (let item of options.items.items) {
            if (!item.person) {
                continue;
            }
            this._items.push(
                new PersonSelectorItem(
                    {
                        container: this._element.querySelector(".person-selector__persons"),
                        data: item,
                        visible: false,
                        onClick: (person) => {
                            this.onSelect.dispatch(person);
                        }
                    }
                ));
        }

        if (typeof options.onSelect === "function") {
            this.onSelect.add(options.onSelect);
        }

        if (!options.visible) {
            this.visible = options.visible;
        }

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public get visible(): boolean {
        return !this._element.classList.contains("person-selector--hidden");
    }

    public set visible(value: boolean) {
        if (this.visible === value) {
            return;
        }
        this._element.classList.toggle("person-selector--hidden", !value);
        this._decoration.visible = value;
        for (let item of this._items) {
            item.visible = value;
        }
    }
}

export interface PersonSelectorItemOptions {
    container: HTMLElement;
    data: VOIntroductionListItem;
    visible?: boolean;
    onClick?: (person: VOIntroductionPerson) => void;
}

class PersonSelectorItem {

    public onClick = e5.Signal.create<[VOIntroductionPerson]>();

    private _element: HTMLElement;
    private _polygon: Polygon;

    constructor(options: PersonSelectorItemOptions) {
        options = e5.object.merge({
            visible: true
        }, options);

        this._element = document.createElement("div");
        this._element.className = "person-selector__item";
        this._element.innerHTML = `
        <div class="person-selector__item-image-container">
            <img class="person-selector__item-image" src="${options.data.person.image?.url}" />
        </div>
        <div class="person-selector__text-container">
            <div class="person-selector__item-name">${e5.Text.escapeHtml(options.data.person.name)}</div>
            <div class="person-selector__item-subtitle">${e5.Text.escapeHtml(options.data.person.subtitle)}</div>
        </div>
        `;

        this._element.style.left = options.data.place.x + "px";
        this._element.style.top = options.data.place.y + "px";

        this._element.addEventListener("click", (e) => {
            this.onClick.dispatch(options.data.person);
        });

        this._polygon = new Polygon({
            shape: options.data.place.shape,
            color: options.data.person.color,
            // gradient: options.backgroundGradient,
            // shadow: options.shadow,
            // shadowAngle: options.shadowAngle,
            // shadowDistance: options.shadowDistance,
            container: this._element,
            prepend: true,
            // background: true
        });

        if (typeof options.onClick === "function") {
            this.onClick.add(options.onClick);
        }

        if (options.visible) {
            this.visible = options.visible;
        }

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public get visible(): boolean {
        return !this._element.classList.contains("person-selector__item--hidden");
    }

    public set visible(value: boolean) {
        this._element.classList.toggle("person-selector__item--hidden", !value);
    }
}